
/**
=========================================================
* Soft UI Dashboard PRO React - v4.0.2
=========================================================

* Product Page: https://www.creative-tim.com/product/soft-ui-dashboard-pro-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import { useRef, useEffect, useState, useMemo } from "react";

// porp-types is a library for typechecking of props
import PropTypes from "prop-types";

// Soft UI Dashboard PRO React components
import SoftBox from "components/SoftComponents/SoftBox";
import SoftAvatar from "components/SoftComponents/SoftAvatar";
import SoftTypography from "components/SoftComponents/SoftTypography";

import Map from "components/Maps/Map";

// Soft UI Dashboard PRO React base styles
import colors from "assets/theme/base/colors";

import Box from '@mui/material/Box';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import { Collapse } from '@mui/material';
import Card from "@mui/material/Card";

import { Route, Link, Routes, useLocation, useNavigate, useMatch } from 'react-router-dom';
import moment from "moment";
import { getUserAccessLevel } from "utils/setup";
import { useSoftUIController } from "hooks/context";

function GroupCard({ group, subgroup = null, user_type = "viewer" }) {
  const navigate = useNavigate();

  const [controller, dispatch] = useSoftUIController();
  const { deviceLayout } = controller;

  const used_group = subgroup != null ? subgroup : group;

  const mapbox_settings = {
    style: 'mapbox://styles/harrymontano/cm01omrnz000u01omf2uegk93?optimize=true',
    zoom: 17,
    interactive: false
  }

  const onSubgroupClick = function (group, e) {
    let path = '/clearways/groups/' + group.group_id + '/subgroups';
    navigate(path);
    e.stopPropagation();
  }

  if (!used_group.all_updated) {
    var polygon_colour = "#ff667c";
  }
  else if (used_group.devices_monitored > 0 && getUserAccessLevel(user_type, 'technician')) {
    var polygon_colour = "#edaa00";
  }
  else {
    var polygon_colour = "#58ba2d";
  }

  return (
    <Link to={'/clearways/groups/' + used_group.group_id} style={{ textDecoration: 'none' }}>
      <Card /*onClick={() => onEventClick(group)}*/ sx={{ cursor: 'pointer' }}>
        <SoftBox p={2}>
          <SoftBox display="flex" alignItems="center">
            <SoftBox lineHeight={0}>
              <SoftBox mb={1} lineHeight={0}>
                <SoftTypography variant="h6" textTransform="capitalize" fontWeight="medium">
                  {used_group.name}
                </SoftTypography>
              </SoftBox>
            </SoftBox>
          </SoftBox>
          <SoftBox display='flex' flexDirection='row' justifyContent='space-between'>
            <SoftBox lineHeight={1} mb={2}>
              {used_group.devices.length == 1 ? (
                <SoftTypography variant="button" fontWeight="regular" color="text">
                  {used_group.devices.length + " Device"}
                </SoftTypography>
              ) : (
                <SoftTypography variant="button" fontWeight="regular" color="text">
                  {used_group.devices.length + " Devices"}
                </SoftTypography>
              )}
            </SoftBox>
            {(typeof used_group.subgroups != 'undefined' && used_group.subgroups.length > 0) && (
              <SoftBox>
                <SoftTypography onClick={(e) => { e.preventDefault(); onSubgroupClick(group, e) }} variant="button" fontWeight="regular" color="text">
                  {"View " + group.subgroups.length + " Subgroups"}
                </SoftTypography>
              </SoftBox>
            )}
          </SoftBox>
          <Card sx={{ height: '200px' }} onClick={(e) => { e.stopPropagation() }}>
            <Map selected_group={used_group} parent_group={subgroup == null ? {} : group} colour={polygon_colour} settings={mapbox_settings} padding={30} />
          </Card>
        </SoftBox>
      </Card>
    </Link>
  );

}

// Typechecking props for the GroupCard
GroupCard.propTypes = {
  group: PropTypes.object,
  subgroup: PropTypes.object,
  user_type: PropTypes.string
};

export default GroupCard;
